import React from 'react';
import { Brain, MessageSquare, Award, Users, Mic } from 'lucide-react';
import { certifications } from '../data/mock';

const iconMap = {
  Brain: Brain,
  MessageSquare: MessageSquare,
  Award: Award,
  Users: Users,
  Mic: Mic
};

const Certifications = () => {
  return (
    <section className="py-24 bg-gray-950 relative">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-16">
            <span className="text-gray-500 text-sm font-mono tracking-wider uppercase">Professional Development</span>
            <h2 className="text-4xl md:text-5xl font-bold text-white mt-4 mb-6">
              Certifications & Training
            </h2>
            <div className="w-20 h-1 bg-white mx-auto"></div>
            <p className="text-gray-400 mt-6 max-w-2xl mx-auto">
              Continuous learning and professional development in marketing, communication, and persuasion techniques
            </p>
          </div>

          {/* Certifications Grid */}
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {certifications.map((cert) => {
              const IconComponent = iconMap[cert.icon];
              return (
                <div
                  key={cert.id}
                  className="bg-black border-2 border-gray-800 rounded-xl p-6 hover:border-white transition-all duration-300 hover:transform hover:-translate-y-2 group"
                >
                  {/* Icon */}
                  <div className="bg-gray-900 group-hover:bg-white w-16 h-16 rounded-xl flex items-center justify-center mb-4 transition-all duration-300">
                    <IconComponent className="w-8 h-8 text-white group-hover:text-black transition-colors duration-300" />
                  </div>

                  {/* Content */}
                  <div className="mb-3">
                    <span className="text-xs text-gray-500 uppercase tracking-wider font-mono">{cert.category}</span>
                  </div>
                  <h3 className="text-white font-bold text-xl mb-3 leading-tight">{cert.title}</h3>
                  <p className="text-gray-500 text-sm leading-relaxed">{cert.description}</p>
                </div>
              );
            })}
          </div>

          {/* Additional info */}
          <div className="mt-12 text-center">
            <div className="inline-block bg-gray-900 border border-gray-800 rounded-xl px-8 py-4">
              <p className="text-gray-400">
                <span className="text-white font-semibold">5</span> professional certifications completed
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Certifications;
